import { render } from "./DetailBasketButton.vue?vue&type=template&id=578f81cc"
import script from "./DetailBasketButton.vue?vue&type=script&lang=js"
export * from "./DetailBasketButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__